import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import moment from 'moment';
import { CongratulationComponent } from "../../../../../../shared/components/congratulation/congratulation.component";
import { AuthService } from "../../../../../../shared/services/auth.service";
import { CurrencyExchangeService } from "../../../../../../shared/services/currency-exchange.service";
import { GetBusinessProfileService } from "../../../../../../shared/services/get-business-profile.service";
import { TitledModalWithContentService } from "../../../../../../shared/services/titled-modal-with-content.service";
import { GetCalculatesParamsService } from "../../../../services/get-calculates-params.service";
import { PaymentOptionsService } from "../../../../services/payment-options.service";
import { ViewProductInfoHandlerService } from "../../../../services/view-product-info-handler.service";
import { BaseBooking } from "./baseCalendar";
import { ProductTypes } from "src/app/shared/product/productTypes";
import { ProductCreationHelperService } from "src/app/dashboard/seller/payment-pages/services/product-creation-helper.service";

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CalendarComponent
  extends BaseBooking
  implements OnInit, OnChanges {
  slotsDays: string[] = [];
  parsedSlots: any[] = [];
  mapCurrency: boolean = false;
  startDay: any;
  endDay: any;
  startTime: any;
  endTime: any;
  url = window.location.href;
  categoryName: any;
  btns = ["facebook"];
  facebookLink: any;
  calendarImage: any;
  description: string = "";
  allSlotsSold: boolean = true;
  isProcessingRequest: boolean = false;
  @ViewChild("coverElement") coverElement!: ElementRef;
  @Input() productObject: any;
  businessObject: any;

  constructor(
    vpihs: ViewProductInfoHandlerService,
    auth: AuthService,
    public titledModal: TitledModalWithContentService,
    getBusinessProfileService: GetBusinessProfileService,
    private Dialog: MatDialog,
    public exchangeService: CurrencyExchangeService,
    private paymentOptionsService: PaymentOptionsService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productCreationHelperService: ProductCreationHelperService
  ) {
    super(
      vpihs,
      auth,
      getBusinessProfileService,
      exchangeService,
      getCalculatesParamsService
    );
  }

  async ngOnInit() {
    this.businessObject = this.productObject.Business;
    await this.paymentOptionsService.make();
    this.description = this.getNewProductValueByFieldName(
      "description",
      "ProductExtraInfos"
    );
    this.calendarImage = this.getNewProductValueByFieldName(
      "image",
      "CalendarExtraInfo"
    );
    this.productObject.CalendarSlots =
      (this.productObject.CalendarSlots as any []).map((slot: any) => {
        const s = slot;
        s["selectedQuantity"] = 0;
        return s;
      });

    await this.initCurrencies();
    this.highlightSlotsDates();

    this.productCreationHelperService.checkParamsForOpriningCopyDialog(window.location.search, {
      serilizedUrl: this.url?.split("?")[0],
      product: {
        name: this.productObject.productName,
        type: ProductTypes.calendar
      }
    })
  }

  ngOnChanges() {
    this.highlightSlotsDates();
  }

  highlightSlotsDates() {
    this.slotsDays = this.productObject.CalendarSlots.map((slot: any) => slot.day);
  }

  dateClass = (d: any): any => {
    let availableDays = this.productObject.CalendarSlots.map((slot: any) => slot.day);
    let date = new Date(d).toDateString();
    if (
      availableDays.includes(date) &&
      new Date().setUTCHours(0, 0, 0, 0) <= d.getTime()
    ) {
      return "custom-date-class";
    }
  };

  availableDaysFilter = (d: Date | null) => {
    if (d) {
      let availableDays = this.productObject.CalendarSlots.map((slot: any) => slot.day);
      const day = new Date(d).toDateString();
      return (availableDays.includes(day));
    }
    return null;
  }

  showSlots(date: any) {
    let selectedDateSlots = this.productObject.CalendarSlots.filter((slot: any) => {
      if (slot.day === date) {
        if (moment().day() === moment(slot.day).day()) {
          return moment(slot.startAt, "HH:mm:ss A") >= moment().add(2, 'h');
        }
        return true;
      }
      return false;
    });
    this.parsedSlots = selectedDateSlots.map((slot: any) => {
      let activeQuantity =
        this.productObject.CalendarExtraInfo.quantity -
        slot.pendingQuantity -
        slot.paidQuantity;
      if (activeQuantity) this.allSlotsSold = false;
      return {
        id: slot.id,
        startAt: moment(slot.startAt, "HH:mm:ss A").format("hh:mm A"),
        endAt: moment(slot.endAt, "hh:mm:ss A").format("hh:mm A"),
        quantity: activeQuantity,
        maxQuantityPerSale: slot.maxQuantityPerSale
          ? Math.min(slot.maxQuantityPerSale, activeQuantity)
          : activeQuantity,
        price: this.productObject.CalendarExtraInfo.price,
        selectedQuantity: slot.selectedQuantity,
      };
    });
  }

  handleDateChange(date: any) {
    //console.log('date', date.toISOString());
    this.showSlots(new Date(date).toDateString());
  }

  async openShareButtonsDialog() {
    this.Dialog.open(CongratulationComponent, {
      panelClass: "responsive-dialog",
      data: {
        url: this.url,
        name: this.productObject.productName,
        type: "Calendar",
        showCongratulation: false,
        showButton: false,
      },
    });
  }

  animationEvent(type: string) {
    let infoBar = document.getElementById('info-bar');
    let productCoverTag = document.getElementById('product-cover-tag');
    if (infoBar && productCoverTag) {
      if (type == 'in') {
        productCoverTag.style.opacity = '.2';
        infoBar.style.marginTop = '2rem';
      } else if (type == 'out') {
        productCoverTag.style.opacity = '1';
        infoBar.style.marginTop = '-6rem';
      };
    }
  }

  proceedToPayment() {
    this.vpihs.setViewInfoObject({
      product: this.productObject,
      extras: this.extrasObject
    });
    this.vpihs.BusinessId = this.productObject.BusinessId;
    this.getCalculatesParamsService.setQuantity(this.quantity);
    this.getCalculatesParamsService.calculateInfos();
    this.vpihs.quantity = this.quantity;
    this.router.navigate(["buyerinfo"], { relativeTo: this.activatedRoute });
  }
}
